import { useHistory } from 'react-router';

type ActionHeaderProps = {
    header: string;
    subHeader?: string;
};

const ActionHeader = ({ header = '', subHeader }: ActionHeaderProps) => {
    const history = useHistory();
    return (
        <h2 className="heading">
            <a onClick={() => history.goBack()}>
                <img src="/images/left-arrow-black.svg" alt="icon" />
            </a>
            {header}
            {subHeader && <span>{subHeader}</span>}
        </h2>
    );
};

export default ActionHeader;
